import React, { useEffect } from 'react';

import { Helmet } from 'react-helmet';
import { useHistory, useParams } from 'react-router-dom';
import { Link } from '~/lib/react-router-dom';

import { Alert, Box, Container, Tab, Tabs } from '@mui/material';

import PageHeader from '~/components/Common/Elements/PageHeader';
import Spinner from '~/components/Common/Spinner';

import { useGetBundle } from '~/hooks/apis/cruises/useGetBundle';

import BundleForm from '../components/BundleForm';

import BundlesFilterList from './BundlesFilter/BundlesFilterList';
import BundlesItemList from './BundlesItem/BundlesItemList';

function BundlesEdit() {
  const { bundleId, tab } = useParams<{ bundleId: string; tab?: string }>();
  const history = useHistory();

  const { data: bundle, isLoading, error } = useGetBundle(bundleId);

  useEffect(() => {
    if (!tab && bundleId) {
      history.replace(`/cruises/bundles/edit/${bundleId}/items`);
    }
  }, [tab, bundleId, history]);

  if (isLoading) {
    return <Spinner />;
  }

  if (error) {
    return (
      <Container maxWidth="xl">
        <Alert severity="error">Error loading bundle: {error.message}</Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl">
      <Helmet>
        <title>Edit Bundle: {bundle?.name}</title>
      </Helmet>

      <PageHeader title={`Edit Bundle: ${bundle?.name || ''}`} backButton="/cruises/bundles" />

      {bundle && (
        <Box mt={1}>
          <Box>
            <BundleForm bundle={bundle} />
          </Box>
          <Box mt={3} border={1} borderColor="divider" borderRadius={1}>
            <Tabs value={tab || false} variant="scrollable">
              <Tab value="items" label="Bundle Items" to={`/cruises/bundles/edit/${bundleId}/items`} component={Link} />
              <Tab
                value="filters"
                label="Bundle Filters"
                to={`/cruises/bundles/edit/${bundleId}/filters`}
                component={Link}
              />
            </Tabs>

            <Box borderTop={1} borderColor="divider">
              {tab === 'items' && <BundlesItemList />}
              {tab === 'filters' && <BundlesFilterList vendorId={bundle.fkVendorId} />}
            </Box>
          </Box>
        </Box>
      )}
    </Container>
  );
}

export default BundlesEdit;
